import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageFactory } from '../../../../../global/components/page-factory';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { unSetEmploymentState } from '../../employment/employment-slice';
import { InstitutionItem } from '../institution-model';
import { unloadInstitutionState } from '../institution-slice';


 const InstitutionLanding = () => {

	const dispatch = useDispatch();

	const list = useSelector<TcsmStates, InstitutionItem[]>(a => a.institutionState?.institutionList);

	useEffect(() => {
		if (list && list.length > 1) {
			dispatch(unloadInstitutionState());
			dispatch(unSetEmploymentState());
		}
	}, []);

	return (
		<>
			<PageFactory />
		</>
	);
};

export default InstitutionLanding;